import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ICellRendererParams } from 'ag-grid-community';
import { CellCustomRenderer } from '../../../shared/ag-grid-table/cell-custom-renderer';
import { SyncToFocusSelect, SyncToFocusSelectProps } from './sync-to-focus-select';

export class SyncToFocusCellRenderer extends CellCustomRenderer {
    setCell(params: ICellRendererParams) {
        const props: SyncToFocusSelectProps = {
            testId: params?.data?.sync_to_focus.testId,
            options: params?.data?.sync_to_focus.options,
            onChange: params?.data?.sync_to_focus.onChange,
        };
        const Component = React.createElement(SyncToFocusSelect, props);
        ReactDOM.render(Component, this.eGui);
    }
}
